import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'cng-agent-view-information',
  templateUrl: 'agent-view-information.component.html',
  styleUrls: ['./agent-view-information.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentViewInformationComponent {}
